import {
  SpaceProps,
  FlexboxProps as ChakraFlexBoxProps,
  PositionProps as ChakraPositionProps,
  BackgroundProps as ChakraBackgroundProps,
  ColorProps as ChakraColorProps,
  BorderProps as ChaakraBorderProps,
} from '@chakra-ui/react';

// These props are from https://chakra-ui.com/docs/styled-system/style-props
// We've selected margins as a group of props to pass into inner components to
// avoid having to wrap custom components around Box or Flex to position them on a page
export type MarginProps = Pick<
  SpaceProps,
  | 'm'
  | 'margin'
  | 'mt'
  | 'marginTop'
  | 'mr'
  | 'marginEnd'
  | 'me'
  | 'marginRight'
  | 'mb'
  | 'marginBottom'
  | 'ml'
  | 'marginStart'
  | 'ms'
  | 'marginLeft'
  | 'mx'
  | 'marginX'
  | 'my'
  | 'marginY'
>;

export type FlexboxProps = Pick<ChakraFlexBoxProps, 'alignSelf' | 'justifySelf'>;

export type PositionProps = ChakraPositionProps;

export type BackgroundProps = ChakraBackgroundProps;

export type ColorProps = ChakraColorProps;

export type BorderProps = ChaakraBorderProps;

export type CommonCIQProps = {
  id?: string;
  ['data-testid']?: string;
};

export type SelectedStyledSystemProps = MarginProps &
  FlexboxProps &
  PositionProps &
  BackgroundProps &
  ColorProps &
  BorderProps;

export enum BlueprintType {
  FLAT_RATE = 'flat_rate',
  TIERED_RATE = 'tiered_rate',
  TRUE_UP = 'true_up',
  CREDITING = 'crediting',
  CONDITIONAL = 'conditional',
}
